// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
  const w = window.innerWidth;
  let showArtboard;
  let hidden1;
  let hidden2;
  if (w > 600) {
    showArtboard = document.getElementById('g-ai2html-graphic-desktop_hidden');
    hidden1 = document.getElementById('g-ai2html-graphic-mobile375_hidden');
    hidden2 = document.getElementById('g-ai2html-graphic-mobile320_hidden');
  } else if (w <= 600 && w >= 343) {
    showArtboard = document.getElementById('g-ai2html-graphic-mobile375_hidden');

    hidden1 = document.getElementById('g-ai2html-graphic-desktop_hidden');
    hidden2 = document.getElementById('g-ai2html-graphic-mobile320_hidden');
  } else if (w < 343) {
    showArtboard = document.getElementById('g-ai2html-graphic-mobile320_hidden');

    hidden1 = document.getElementById('g-ai2html-graphic-desktop_hidden');
    hidden2 = document.getElementById('g-ai2html-graphic-mobile375_hidden');
  }

  document.getElementById('wtBtMore').addEventListener('click', () => {
    showArtboard.style.display = 'block';


    document.getElementById('wtBtMore').style.display = 'none';
    document.getElementById('wtBtLess').style.display = 'block';
    setTimeout(() => {
      pymChild.sendHeight();
    }, 100);
  });
  document.getElementById('wtBtLess').addEventListener('click', () => {
    // for (let i = 0; i < elements.length; i++) {

    showArtboard.style.display = 'none';

    document.getElementById('wtBtLess').style.display = 'none';
    document.getElementById('wtBtMore').style.display = 'block';
    setTimeout(() => {
      pymChild.sendHeight();
    }, 100);
  });
}
